<template>
  <div class="container-fluid mt-4">
    <b-row class="mb-3 border-bottom">
      <b-col>
        <span :class="`size-${ButtonSize}`">Ürün Ekle</span>
      </b-col>

      <b-col cols="auto" class="text-right">
        <b-btn class="mr-3" type="button" variant="danger" to="/Products" :size="ButtonSize">
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1">Ürünler</span>
        </b-btn>
      </b-col>
    </b-row>

    <b-alert show variant="danger" v-if="Object.keys(CategoriesGUI).length === 0">
      Sisteminizde ekli
      <strong>kategori</strong> bulunamamıştır.
      <br />Ürün eklemek için lütfen kategori tanımlaması yapınız.
    </b-alert>

    <b-alert show variant="danger" v-if="Object.keys(KitchensGUI).length === 0">
      Sisteminizde ekli
      <strong>mutfak</strong> bulunamamıştır.
      <br />Ürün eklemek için lütfen mutfak tanımlaması yapınız.
    </b-alert>

    <form
      @submit.prevent="AddProduct"
      v-if="Object.keys(CategoriesGUI).length > 0 && Object.keys(KitchensGUI).length > 0"
    >
      <b-form-group class="formgroup" label="Kategori">
        <b-form-select v-model="Product.CategoryID" :options="CategoriesGUI"></b-form-select>
      </b-form-group>

      <b-form-group class="formgroup" label="Mutfak">
        <b-form-select v-model="Product.KitchenID" :options="KitchensGUI"></b-form-select>
      </b-form-group>

      <b-form-group
        class="formgroup"
        :label="Enums[index]"
        v-for="(property, index) in ProductGUI"
        :key="index"
      >
        <b-form-input type="text" v-model="Product[index]" @keypress.enter.prevent="AddProduct"></b-form-input>
      </b-form-group>

      <div class="m-t-40 d-block border-top pt-3 pl-3">
        <b-btn type="submit" variant="success" size="lg">
          <i class="material-icons mifix">save</i>
          <span class="ml-1">Ekle</span>
        </b-btn>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Services from "../Service";

export default {
  data() {
    return {
      Enums: {
        Name: "Ürün Adı",
        Portions: "Artış Miktarı",
        MinPortion: "Min. Porsiyon",
        Price: "Fiyat",
        Sort: "Sıralama"
      },
      Product: {
        CategoryID: 0,
        KitchenID: 0,
        Name: "",
        Price: 0,
        MinPortion: 0,
        Portions: 0,
        Sort: 0
      }
    };
  },
  computed: {
    ...mapGetters(["GetStoreData"]),
    ...mapState(["ButtonSize"]),
    ProductGUI() {
      return Object.filterKey(
        this.Product,
        x =>
          ["CategoryID", "KitchenID", "Extras", "ExtraTypes", "Status"].indexOf(
            x
          ) === -1
      );
    },
    CategoriesGUI() {
      let _Categories = [];

      for (let i in this.GetStoreData.Categories) {
        const _Category = this.GetStoreData.Categories[i];

        _Categories.push({
          value: _Category.ID,
          text: _Category.Name
        });
      }

      return _Categories;
    },
    KitchensGUI() {
      let _Kitchens = [];

      for (let i in this.GetStoreData.Kitchens) {
        const _Kitchen = this.GetStoreData.Kitchens[i];

        _Kitchens.push({
          value: _Kitchen.ID,
          text: _Kitchen.Name
        });
      }

      return _Kitchens;
    }
  },
  methods: {
    async AddProduct() {
      await this.$store.dispatch("AddLoading", "AddProduct");

      await Services.Nozich.Send(
        "AddProduct",
        {
          Product: this.Product
        },
        async Data => {
          await this.$store.dispatch("RemoveLoading", "AddProduct");

          if (Data.Status === "Success") {
            await this.$router.push("/Products");
          }
        }
      );
    }
  },
  mounted() {
    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });
  }
};
</script>
